import { useTheme } from "@/src/styles/theme-provider";
import { useTranslation } from "react-i18next";
import { Text, TextInput, View } from "react-native";

type ScInputProps = Readonly<{
  label: string;
  placeholder: string;
  value: string;
  onChangeText: (text: string) => void;
  editable?: boolean;
  error?: string;
}>;

const ScInput = ({
  label,
  placeholder,
  value,
  onChangeText,
  editable = true,
  error,
}: ScInputProps) => {
  "use no memo";
  const { t } = useTranslation();
  const { themeVars } = useTheme();

  return (
    <View className="flex-1 gap-1">
      <Text className="text-base text-onyx">{t(label)}</Text>
      <TextInput
        placeholder={t(placeholder)}
        placeholderTextColor={themeVars["--color-slate-default"]}
        className={`md:border rounded-xl text-base px-3 py-3 bg-ash focus:border-primary ${
          error ? "border-crimson md:border-crimson" : "md:border-ash-3"
        } ${editable ? "text-onyx" : "text-slate opacity-70"}`}
        value={value}
        onChangeText={onChangeText}
        editable={editable}
        style={{ outlineStyle: "none" } as any}
      />
      {error ? <Text className="text-xs text-crimson">{t(error)}</Text> : null}
    </View>
  );
};
export default ScInput;
